export const formatDate = (date: Date): string => {
  const year = date.getFullYear()
  // getMonth() は 0 から始まるので、1 を加えて修正する。
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')

  return `${year}/${month}/${day}`
}

export const getKuchikomiDate = (date: string) => {
  const currentDate = new Date()
  const dateObj = new Date(date)
  const dateDiffMiliSec = currentDate.getTime() - dateObj.getTime()
  const oneHourMiliSec = 1000 * 60 * 60
  const oneDayMiliSec = 1000 * 60 * 60 * 24
  const oneWeekMiliSec = oneDayMiliSec * 7
  const oneMonthMiliSec = oneDayMiliSec * 30
  const threeMonthsMiliSec = oneMonthMiliSec * 3
  const sixMonthsMiliSec = oneMonthMiliSec * 6
  const oneYearMiliSec = oneDayMiliSec * 365

  if (dateDiffMiliSec < oneHourMiliSec) {
    return `${String(Math.ceil(dateDiffMiliSec / 1000 / 60))}分前`
  }

  if (dateDiffMiliSec < oneDayMiliSec) {
    return `${String(Math.ceil(dateDiffMiliSec / 1000 / 60 / 60))}時間前`
  }

  // For dates between 1 day and 1 week, still show formatted date
  if (dateDiffMiliSec < oneWeekMiliSec) {
    return formatDate(dateObj)
  }

  if (dateDiffMiliSec < oneMonthMiliSec) {
    return '1週間以上前'
  }

  if (dateDiffMiliSec < threeMonthsMiliSec) {
    return '1ヶ月以上前'
  }

  if (dateDiffMiliSec < sixMonthsMiliSec) {
    return '3ヶ月以上前'
  }

  if (dateDiffMiliSec < oneYearMiliSec) {
    return '半年以上前'
  }

  const years = Math.floor(dateDiffMiliSec / oneYearMiliSec)
  return `${years}年以上前`
}
